import { render, staticRenderFns } from "./SingleVideoPainel.vue?vue&type=template&id=642d0642&scoped=true&"
import script from "./SingleVideoPainel.vue?vue&type=script&lang=js&"
export * from "./SingleVideoPainel.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=642d0642&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642d0642",
  null
  
)

export default component.exports